export default __webpack_public_path__ + "static/media/lds-logo_fj.1fd425f10998c6d0.svg";